import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const accountIssueRepository =
  repositoryHost.getAccountIssueRepository(databaseService);

export const useAccountIssuesByInventoryId = (inventoryId: string) => {
  return useQuery({
    queryKey: ["account-issues", "by-inventory", inventoryId],
    enabled: inventoryId.length > 0,
    queryFn: async () =>
      accountIssueRepository.getAll({
        queryConstraints: [
          {
            field: "inventoryId",
            operator: "==",
            value: inventoryId,
          },
        ],
        orderBy: {
          field: "createdAt",
          direction: "desc",
        },
        pagination: {
          limit: 200,
        },
      }),
  });
};
